import { render, staticRenderFns } from "./HiredServiceCard.vue?vue&type=template&id=37bb05f0&"
import script from "./HiredServiceCard.vue?vue&type=script&lang=js&"
export * from "./HiredServiceCard.vue?vue&type=script&lang=js&"
import style0 from "./HiredServiceCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports